var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:({width: _vm.width})},[_c('div',{class:[
        _vm.className,{
        'completed-step-l1-scoped': _vm.stepCompleted,
        'completed-line-l1-scoped': _vm.lineCompleted
    }]})])
}
var staticRenderFns = []

export { render, staticRenderFns }